const publicHealthCitizenMoreInformationSchema = {
  hasAnyDisability: {
    displayName: 'PCD',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isPregnant: {
    displayName: 'Grávida',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  currentWeightStatus: {
    displayName: 'Estado nutricional',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'weight',
  },
  smoker: {
    displayName: 'Fumante',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  consumesAlcoholicBeverages: {
    displayName: 'Consome bebida alcoólica',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  takeDrugs: {
    displayName: 'Usa drogas',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasHypertension: {
    displayName: 'É hipertenso',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasDiabetes: {
    displayName: 'Possui diabetes',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hadStroke: {
    displayName: 'Teve AVC',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hadHeartAttack: {
    displayName: 'Teve infarto',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasHeartDisease: {
    displayName: 'Possui doença cardíaca',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  whichHeartDisease: {
    displayName: 'Doença cardíaca',
    type: 'string',
    notAvailable: 'Não informado',
  },
  hadKidneyDisease: {
    displayName: 'Teve doença renal',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  whichKidneyDisease: {
    displayName: 'Doença renal',
    type: 'string',
    notAvailable: 'Doença renal não informada',
  },
  hasRespiratoryDisease: {
    displayName: 'Possui doença respiratória',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  whichRespiratoryDisease: {
    displayName: 'Doença respiratória',
    type: 'string',
    notAvailable: 'Doença respiratória não informada',
  },
  hasLeprosy: {
    displayName: 'Possui hanseníase',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasTuberculosis: {
    displayName: 'Possui tuberculose',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hadCancer: {
    displayName: 'Teve câncer',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasMedicalProfessionalDiagnosisOfMentalConditions: {
    displayName: 'Possui diagnóstico de saúde mental',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isBedridden: {
    displayName: 'É acamado',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isDomiciled: {
    displayName: 'É domiciliado',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  haveOtherHealthConditions: {
    displayName: 'Outras condições de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  homeless: {
    displayName: 'Em situação de rua',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  homelessForHowManyTime: {
    displayName: 'Tempo em situação de rua',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'homelessTime',
  },
  receivesBenefit: {
    displayName: 'Recebe benefício',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
}

export default publicHealthCitizenMoreInformationSchema
